import { createSelector } from "reselect";
import { IGCPBigQueryJob, IRootReducer } from "../../Models/Models";
import { gpsInsightForReportView } from "./GPSInsightsSelectors";

export const getPolygonNamesForSelectedGpsInsight = createSelector(
    gpsInsightForReportView,
    (jobs: IGCPBigQueryJob[]) => jobs.map((j) => j.jobPolygon.name)
);
